import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    uploadPublicProjectFileRequest: ['response'],
    uploadPublicProjectFileSuccess: ['loading', 'response'],
    uploadPublicProjectFileFailure: ['error'],
})

export const uploadPublicProjectFileTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const uploadPublicProjectFileRequest = state =>
    state.merge({ success: null, loading: true })

const uploadPublicProjectFileSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        loading: false,
        response,
    })

const uploadPublicProjectFileFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        loading: false,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.UPLOAD_PUBLIC_PROJECT_FILE_REQUEST]: uploadPublicProjectFileRequest,
    [Types.UPLOAD_PUBLIC_PROJECT_FILE_SUCCESS]: uploadPublicProjectFileSuccess,
    [Types.UPLOAD_PUBLIC_PROJECT_FILE_FAILURE]: uploadPublicProjectFileFailure,
})
